// @flow

import type { Action } from './store.type';
import { ThemesType } from 'src/models/theme-setup';

export const SI_GET_ALL_THEMES_REQUEST = 'SI_GET_ALL_THEMES_REQUEST';
type SI_GET_ALL_THEMES_REQUEST_TYPE = 'SI_GET_ALL_THEMES_REQUEST';

export const SI_GET_ALL_THEMES_SUCCESS = 'SI_GET_ALL_THEMES_SUCCESS';
type SI_GET_ALL_THEMES_SUCCESS_TYPE = 'SI_GET_ALL_THEMES_SUCCESS';

export const SI_GET_ALL_THEMES_FAILURE = 'SI_GET_ALL_THEMES_FAILURE';
type SI_GET_ALL_THEMES_FAILURE_TYPE = 'SI_GET_ALL_THEMES_FAILURE';

type SIThemeFailure = {
  error: any
};

type SIGetAllThemesRequestAction = Action<SI_GET_ALL_THEMES_REQUEST_TYPE, null>;

type SIGetAllThemesSuccessAction = Action<SI_GET_ALL_THEMES_SUCCESS_TYPE, { data: ThemesType }>;

type SIGetAllThemesFailureAction = Action<SI_GET_ALL_THEMES_FAILURE_TYPE, SIThemeFailure>;

export const SI_GET_ALL_THEMES_SHOPIFY_REQUEST = 'SI_GET_ALL_THEMES_SHOPIFY_REQUEST';
type SI_GET_ALL_THEMES_SHOPIFY_REQUEST_TYPE = 'SI_GET_ALL_THEMES_SHOPIFY_REQUEST';

export const SI_GET_ALL_THEMES_SHOPIFY_SUCCESS = 'SI_GET_ALL_THEMES_SHOPIFY_SUCCESS';
type SI_GET_ALL_THEMES_SHOPIFY_SUCCESS_TYPE = 'SI_GET_ALL_THEMES_SHOPIFY_SUCCESS';

export const SI_GET_ALL_THEMES_SHOPIFY_FAILURE = 'SI_GET_ALL_THEMES_SHOPIFY_FAILURE';
type SI_GET_ALL_THEMES_SHOPIFY_FAILURE_TYPE = 'SI_GET_ALL_THEMES_SHOPIFY_FAILURE';

type SIGetAllThemesShopifyRequestAction = Action<SI_GET_ALL_THEMES_SHOPIFY_REQUEST_TYPE, null>;

type SIGetAllShopifySuccessAction = Action<
  SI_GET_ALL_THEMES_SHOPIFY_SUCCESS_TYPE,
  { data: ThemesType }
>;

type SIGetAllShopifyFailureAction = Action<SI_GET_ALL_THEMES_SHOPIFY_FAILURE_TYPE, SIThemeFailure>;

export const SI_UPDATE_ALL_THEMES = 'SI_UPDATE_ALL_THEMES';
type SI_UPDATE_ALL_THEMES_TYPE = 'SI_UPDATE_ALL_THEMES';

type SIUpdateAllThemesAction = Action<SI_UPDATE_ALL_THEMES_TYPE, { data: any }>;

export const SI_GET_THEME_DETAIL_REQUEST = 'SI_GET_THEME_DETAIL_REQUEST';
type SI_GET_THEME_DETAIL_REQUEST_TYPE = 'SI_GET_THEME_DETAIL_REQUEST';

export const SI_GET_THEME_DETAIL_SUCCESS = 'SI_GET_THEME_DETAIL_SUCCESS';
type SI_GET_THEME_DETAIL_SUCCESS_TYPE = 'SI_GET_THEME_DETAIL_SUCCESS';

export const SI_GET_THEME_DETAIL_FAILURE = 'SI_GET_THEME_DETAIL_FAILURE';
type SI_GET_THEME_DETAIL_FAILURE_TYPE = 'SI_GET_THEME_DETAIL_FAILURE';

type SIGetThemeDetailRequestAction = Action<SI_GET_THEME_DETAIL_REQUEST_TYPE, null>;

type SIGetThemeDetailSuccessAction = Action<SI_GET_THEME_DETAIL_SUCCESS_TYPE, { data: ThemesType }>;

type SIGetThemeDetailFailureAction = Action<SI_GET_THEME_DETAIL_FAILURE_TYPE, SIThemeFailure>;

export const SI_RESET_CACHE_THEMES = 'SI_RESET_CACHE_THEMES';
type SI_RESET_CACHE_THEMES_TYPE = 'SI_RESET_CACHE_THEMES';

type SIResetCacheThemesAction = Action<SI_RESET_CACHE_THEMES_TYPE, null>;

export type SIThemeAction =
  | SIGetAllThemesRequestAction
  | SIGetAllThemesSuccessAction
  | SIGetAllThemesFailureAction
  | SIUpdateAllThemesAction
  | SIGetThemeDetailRequestAction
  | SIGetThemeDetailSuccessAction
  | SIGetThemeDetailFailureAction
  | SIGetAllThemesShopifyRequestAction
  | SIGetAllShopifySuccessAction
  | SIGetAllShopifyFailureAction
  | SIResetCacheThemesAction;

export type SIThemeState = {
  getAllThemesLoading: boolean,
  allThemes: ThemesType | [],
  total: number,
  themeDetail: any,
  themeDetailLoading: boolean,
  themeDetailSuccess: boolean,
  themeDetailError: any
};
